import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import client from '@services/graphqlService';
import { Routes } from './routes/routes';
import 'antd/dist/antd.css';
import 'react-quill-new/dist/quill.snow.css';
import './index.less';
import '@new/globals.css';
import { httpClient } from '@teachur/http-client';

import * as Sentry from '@sentry/react';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'sonner';

import { AppErrorFallback } from '@new/common/ui/AppErrorFallback/AppErrorFallback';
import { initSentry } from '@new/lib/sentry';

const DEFAULT_API_URL = 'http://localhost:3000';

// Configure HTTP Client
httpClient.configure({
  baseURL: import.meta.env.VITE_API_URL || DEFAULT_API_URL,
});

// Restore auth token if exists
const token = localStorage.getItem('accessToken');
if (token) {
  httpClient.setAuthToken(token);
}

initSentry();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Sentry.ErrorBoundary fallback={({ resetError }) => <AppErrorFallback resetError={resetError} />}>
    <ApolloProvider client={client}>
      <Toaster position="top-center" richColors />
      <ToastContainer position="top-center" />
      <Routes />
    </ApolloProvider>
  </Sentry.ErrorBoundary>
);
